export default [
  {
    path: '/analytics/:id',
    name: 'analytics',
    component: () => import(/* webpackChunkName: "analytics" */ '@/views/station/Analytics.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics-old/:id',
    name: 'analytics-old',
    component: () => import(/* webpackChunkName: "analytics-old" */ '@/views/station/AnalyticsOld.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/gallery/:id',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "gallery" */ '@/views/station/Gallery.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pdf/:id',
    name: 'pdf',
    component: () => import(/* webpackChunkName: "pdf" */ '@/views/station/Pdf.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/schema/:id',
    name: 'schema',
    component: () => import(/* webpackChunkName: "schema" */ '@/views/station/Schema.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/station-view/:id',
    name: 'station-view',
    component: () => import(/* webpackChunkName: "stations-view" */ '@/views/station/StationView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics/:id',
    name: 'statistics',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/station/Statistics.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/weather/:id',
    name: 'weather',
    component: () => import(/* webpackChunkName: "weather" */ '@/views/station/Weather.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inverters/:id',
    name: 'inverters',
    component: () => import(/* webpackChunkName: "weather" */ '@/views/station/Inverters.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inverters-new/:id',
    name: 'inverters-new',
    component: () => import(/* webpackChunkName: "weather" */ '@/views/station/InvertersNew.vue'),
    meta: { requiresAuth: true }
  }
]
